let suppressionResolver: () => boolean = () => false;

// Resolved per call rather than pushed from a React effect, so the first events of a session (the initial page
// view fires from a router subscription) already see it.
export function setMixpanelSuppressionResolver(resolver: () => boolean): void {
    suppressionResolver = resolver;
}

export function isMixpanelSuppressed(): boolean {
    return suppressionResolver();
}
